import React, { useMemo } from 'react';
import { StockReportList } from '../../../../helpers/models/Models';
import AppTable from '../../../../constants/AppTable';

interface StockListReportProps {
  stockReport: StockReportList[] | null;
}

const StockReportListView: React.FC<StockListReportProps> = ({ stockReport }) => {
  const columns = [
    { header: 'Product ID', accessor: 'product_id', sortable: true },

    { header: 'Product Name', accessor: 'product_name', sortable: false },
    { header: 'Total/Sales/Issue/Aval.', accessor: 'total', sortable: true },
    { header: 'Store Name', accessor: 'store_name', sortable: false },
    { header: 'Dis. Amt', accessor: 'disc_amt', sortable: false },
    { header: 'Dis. Per.', accessor: 'disc_perc', sortable: false },
    { header: 'VAT %', accessor: 'vat_perc', sortable: false },
  ];

  const modifiedData = useMemo(() => {
    if (!stockReport) return [];
    return stockReport.map((item) => ({
      product_name: item.pro_name,
      product_id: item.product_id,
      store_name: item.store_name,
      total: item.total,
      disc_amt: item.disc_amt,
      disc_perc: item.disc_perc,
    }));
  }, [stockReport]);

  return (
    <div>
      <AppTable
        columns={columns}
        data={modifiedData}
      />
    </div>
  );
};

export default StockReportListView;
